// Module
var code = "<div ng-if=\"!ctrl.onInitiating\" class=\"search-page\"> <runner-page-description is-show=\"!isMobile\" page-header-text=\"{{ctrl.pageHeaderText}}\" page-description=\"{{ctrl.pageDescription}}\"></runner-page-description> <div class=\"mt-20\"> <flows-imin-groups groups=\"ctrl.groups\"></flows-imin-groups> </div> </div> ";
// Exports
export default code;